<!--
  관리자 설정 > 공통 언어 설정

  @since: 2019-09-17
  @author: mk.ko
-->

<template>
  <!-- 언어 설정   -->
  <div class="content-group">
    <div class="contents-row">
      <div class="page-title-1depth">
        <span class="page-title-1depth-text">{{$t('cmn.useLanguage')}}</span>
      </div>

      <div class="contents-row">
        <div class="portlet">
          <div class="contents-row">
            <q-select v-model = "adminDetail.admin_locale_type"
                      :disable="isReadOnly"
                      :options="selectOptionsLocales"
                      class="bs bs-q-select bs-q-select-default f-left">
            </q-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const { mapState } = createNamespacedHelpers('system/adminSettings/adminGroupSettings')

  import { fnGetCodeList } from '~/utils/admin-common'

  export default {
    name: 'AdminLocale',
    created () {},
    props: {
      isReadOnly: {
        type: Boolean,
        default: false
      }
      // externalAuth: {
      //   type: Boolean,
      //   default: false
      // }
    },
    computed: {
      ...mapState([
        // 'adminGeneral',
        'adminDetail'
        // 'generalConfig'
      ]),
      // 언어 선택
      selectOptionsLocales () {
        return fnGetCodeList('admin_locale_type')
      }
    },
    data () {
      return {}
    },
    methods: {},
    watch: {}
  }
</script>

<style scoped>
</style>

